<script setup>
  import Hft_ContentBox from '@/components/microsites/HeadingForTomorrow/components/Hft_ContentBox.vue'
  import Hft_SectionWrapper from '@/components/microsites/HeadingForTomorrow/components/Hft_SectionWrapper.vue'
  import { useWindowSize } from '@vueuse/core'
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/ScrollTrigger'
  import { computed, onMounted, ref } from 'vue'
  const { width } = useWindowSize()
  const isMobile = computed(() => width.value < 1024)
  const activeBubbles = ref(0)
  const maxActiveBubbles = ref(60)
  gsap.registerPlugin(ScrollTrigger)
  const stars = ref([])
  onMounted(() => {})

  import headshot1 from '@/assets/images/microsites/headingfortomorrow/dave/box1/headshot-1.png'
  import headshot2 from '@/assets/images/microsites/headingfortomorrow/dave/box1/headshot-2.png'
  import headshot3 from '@/assets/images/microsites/headingfortomorrow/dave/box1/headshot-3.png'
  import ss1 from '@/assets/images/microsites/headingfortomorrow/dave/box1/ss-1.jpg'
  import ss2 from '@/assets/images/microsites/headingfortomorrow/dave/box1/ss-2.jpg'
  import ss3 from '@/assets/images/microsites/headingfortomorrow/dave/box1/ss-3.jpg'

  const boxData = [
    {
      title: 'EXPLORE THE BLUE HOLE',
      p: `Dive into the Blue Hole and seek out exotic fish to serve at <span>Bancho Sushi</span>! <br /><br /><span>Upgrade your diving gear</span>
            with the money you earn from the restaurant to help you catch bigger and rarer fish!`,
      headshot: headshot1,
      ss: ss1,
    },
    {
      title: 'BANCHO SUSHI',
      p: `Help run <span>Bancho Sushi</span> in MapleStory! <br/><br/>Use seafood from the Blue Hole to <span>cook and upgrade dishes</span>, and use the money you earn to hire <span>Maple World residents</span> to join your team!`,
      headshot: headshot2,
      ss: ss2,
    },
    {
      title: 'BLUE HOLE CODEX',
      p: `Explore the Blue Hole, complete the Blue Hole Codex, and <span>unlock exclusive items</span>!`,
      headshot: headshot3,
      ss: ss3,
    },
  ]

  const bgContainer = ref(null)
  function bubble() {
    if (isMobile.value) return
    if (activeBubbles.value >= maxActiveBubbles.value) return

    activeBubbles.value++
    const $bubble = document.createElement('div')
    $bubble.classList.add('m-headingForT-dav-bgs__bubble')
    bgContainer.value.appendChild($bubble)

    // Random position and rotation
    const startX = Math.random() * window.innerWidth
    $bubble.style.left = `${startX}px`

    const randomSize = 0.5 + Math.pow(Math.random(), 3) * 3.5
    $bubble.style.width = `${randomSize}vw`
    $bubble.style.height = `${randomSize}vw`

    const bubbleStartBottomPosition = Math.floor(Math.random() * 180) + 1
    const bubbleEndBottomPosition = Math.floor(Math.random() * 31) + 50 + bubbleStartBottomPosition
    // Animation
    setTimeout(() => {
      $bubble.style.bottom = `${bubbleStartBottomPosition}vw`
      $bubble.style.opacity = '1'
      $bubble.style.transition = 'bottom 20s linear, left 12s linear, opacity 1s'
    }, 1000)
    setTimeout(() => {
      $bubble.style.bottom = `${bubbleEndBottomPosition}vw`
    }, 1100)

    // Remove after animation
    setTimeout(() => {
      $bubble.style.opacity = '0'
    }, 5500)
    setTimeout(() => {
      $bubble.remove()
      activeBubbles.value--
    }, 5950)
  }

  function showBubble() {
    bubble()
    setInterval(bubble, 200)
  }

  onMounted(() => {
    showBubble()
    if (window.innerWidth >= 1024) {
      const top = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-dav__logo',
          start: 'top 95%',
          toggleActions: 'play none none none',
        },
      })
      top.fromTo(
        '.m-headingForT-dav__logo, .m-headingForT-dav-top-title, .m-headingForT-dav__video',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      top.fromTo(
        '.m-headingForT-dav-bgs__pinkbean, .m-headingForT-dav-bgs__robot, .m-headingForT-dav-bgs__bancho, .m-headingForT-dav-bgs__dave',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, delay: 0.5, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      const tl_box1 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-dav-box1',
          start: 'top 95%',
          toggleActions: 'play none none none',
        },
      })
      tl_box1.fromTo(
        '.m-headingForT-dav-box1',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box1.fromTo(
        '.m-headingForT-dav-bgs__rock-left',
        { x: '-100%' },
        { x: 0, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )

      tl_box1.fromTo(
        '.m-headingForT-dav-box1__btn',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box1.fromTo(
        '.m-headingForT-dav-bgs__rock-right',
        { x: '100%' },
        { x: 0, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box1.fromTo(
        '.m-headingForT-dav-bgs__yeti-mushroom',
        { x: '-100%', opacity: 0 },
        { x: 0, opacity: 1, delay: 0.5, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box1.fromTo(
        '.m-headingForT-dav-bgs__dave-big',
        { x: '100%', opacity: 0 },
        { x: 0, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )

      const tl_box2 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-dav-box2',
          start: 'top 95%',
          toggleActions: 'play none none none',
        },
      })

      tl_box2.fromTo(
        '.m-headingForT-dav-box2-titles',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
        '<'
      )

      tl_box2.fromTo(
        '.m-headingForT-dav-box2',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
        '<'
      )

      tl_box2.fromTo(
        '.m-headingForT-dav-bgs__character-1',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, delay: 0.5, duration: 1, ease: 'power2.out' },
        '<'
      )

      tl_box2.fromTo(
        '.m-headingForT-dav-bgs__character-2',
        { scale: 1.15, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
        '<'
      )

      const tl_box3 = gsap.timeline({
        scrollTrigger: {
          trigger: '.m-headingForT-dav-box3',
          start: 'top 95%',
          toggleActions: 'play none none none',
        },
      })
      tl_box3.fromTo(
        '.m-headingForT-dav-box3',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box3.fromTo(
        '.m-headingForT-dav-box3-titles',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box3.fromTo(
        '.m-headingForT-sia-box3__learn-more',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, duration: 1.5, ease: 'power2.out' },
        '<'
      )
      tl_box3.fromTo(
        '.m-headingForT-dav-bgs__character-3',
        { scale: 1.2, opacity: 0 },
        { scale: 1, opacity: 1, delay: 0.3, duration: 1.5, ease: 'power2.out' },
        '<'
      )
    }
  })
</script>

<template>
  <Hft_SectionWrapper class="m-headingForT-dav">
    <div ref="bgContainer" class="m-headingForT-dav-bgs">
      <img class="m-headingForT-dav-bgs__boat" src="@/assets/images/microsites/headingfortomorrow/dave/bg/boat.png" />
      <img
        class="m-headingForT-dav-bgs__pinkbean"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/pinkbean.gif"
      />
      <img class="m-headingForT-dav-bgs__robot" src="@/assets/images/microsites/headingfortomorrow/dave/bg/robot.gif" />
      <img
        class="m-headingForT-dav-bgs__bancho"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/bancho.gif"
      />
      <img class="m-headingForT-dav-bgs__dave" src="@/assets/images/microsites/headingfortomorrow/dave/bg/dave.gif" />
      <img
        class="m-headingForT-dav-bgs__yeti-mushroom"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/yeti-mushroom.gif"
      />
      <img
        class="m-headingForT-dav-bgs__rock-left"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/rock-left.png"
      />
      <img
        class="m-headingForT-dav-bgs__dave-big"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/dave-big.png"
      />
      <img
        class="m-headingForT-dav-bgs__rock-right"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/rock-right.png"
      />
      <img
        class="m-headingForT-dav-bgs__character-1"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/character-1.png"
      />
      <img
        class="m-headingForT-dav-bgs__character-2"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/character-2.png"
      />
      <img
        class="m-headingForT-dav-bgs__character-3"
        src="@/assets/images/microsites/headingfortomorrow/dave/bg/character-3.png"
      />
    </div>
    <div class="m-headingForT-dav__overal-content">
      <img class="m-headingForT-dav__logo" src="@/assets/images/microsites/headingfortomorrow/dave/logo.png" alt="" />
      <div class="m-headingForT-dav-top-title">
        <div class="m-headingForT__sub-title">Available Now!</div>
      </div>

      <div class="m-headingForT-dav__video">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/5KCm8s3nbrI"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
      <Hft_ContentBox :type="'v2'" class="m-headingForT-dav-box1">
        <div class="m-headingForT-dav-box1-items">
          <div
            v-for="(item, index) in boxData"
            :key="`m-headingForT-dav-box1-item--${index + 1}`"
            class="m-headingForT-dav-box1-item"
            :class="`m-headingForT-dav-box1-item--${index + 1}`"
          >
            <img class="m-headingForT-dav-box1-item__headshot" :src="item.headshot" alt="" />
            <div class="m-headingForT-dav-box1-item__title">{{ item.title }}</div>
            <!-- eslint-disable vue/no-v-html -->
            <div class="m-headingForT-dav-box1-item__p">
              <div class="m-headingForT-dav-box1-item__p-text" v-html="item.p"></div>
            </div>
            <img class="m-headingForT-dav-box1-item__ss" :src="item.ss" />
          </div>
        </div>
      </Hft_ContentBox>

      <a v-ga-event="'Learn More Button'" href="https://www.nexon.com/maplestory/news/events/28138" target="_blank">
        <Hft_Btn class="m-headingForT-dav-box1__btn" :color="'yellow'" />
      </a>

      <div class="m-headingForT-dav-box2-titles">
        <div class="m-headingForT__title">New 6<sup>th</sup> Job Mastery Nodes</div>
        <div class="m-headingForT__sub-title">Available Now!</div>
      </div>
      <Hft_ContentBox :type="'v2'" class="m-headingForT-dav-box2">
        <div class="m-headingForT-sia-box2__top-content">
          <img
            class="m-headingForT-sia-box2__ss"
            src="@/assets/images/microsites/headingfortomorrow/dave/box2/ss.jpg"
          />
          <div class="m-headingForT-sia-box2__text-wrapper">
            <div class="m-headingForT-sia-box2__text">
              Power up key skills for your Jobs with the 3<sup>rd</sup> and 4<sup>th</sup> HEXA Mastery Nodes!
            </div>
          </div>
        </div>

        <div class="m-headingForT-sia-box2__video">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/o29nSmv2hns"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="m-headingForT-dav-box2__bg"></div>
      </Hft_ContentBox>

      <div class="m-headingForT-dav-box3-titles">
        <div class="m-headingForT__title">Ride or Die Returns!</div>
        <div class="m-headingForT__sub-title">Available Now!</div>
      </div>
      <Hft_ContentBox :type="'v2'" class="m-headingForT-dav-box3">
        <div class="m-headingForT-dav-box3__text">
          Kazax is back for more, and his minions have only grown stronger. Join the Inspectors in the next part of this
          GMS-exclusive event for more incredible boss battles and a new set of special rewards to earn!
        </div>
      </Hft_ContentBox>
      <a v-ga-event="'Learn More Button'" href="https://www.nexon.com/maplestory/news/events/28139" target="_blank">
        <Hft_Btn class="m-headingForT-sia-box3__learn-more" :color="'yellow'" />
      </a>
    </div>
  </Hft_SectionWrapper>
</template>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/headingfortomorrow/fonts.scss' as *;
  @use '@/assets/scss/microsites/headingfortomorrow/variables.scss' as *;
  .m-headingForT-dav {
    background: url('~@/assets/images/microsites/headingfortomorrow/dave/bg.jpg') no-repeat center top / 100% auto;
    text-align: center;
    padding-bottom: 8.5vw;
  }

  .m-headingForT-dav__overal-content {
    overflow: hidden;
  }

  [class^='m-headingForT-dav-bgs__'] {
    position: absolute;
    height: auto;
  }

  .m-headingForT-dav-bgs {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    :deep(.m-headingForT-dav-bgs__bubble) {
      position: absolute;
      /* bottom: 0; */
      opacity: 0;
      transition: opacity 1s;
      background: url('~@/assets/images/microsites/headingfortomorrow/dave/bg/bubble.png') no-repeat center center /
        100% auto;
    }
  }

  @keyframes m-headingForT-dav-bgs__boat {
    0% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-11px) rotate(0.6deg);
    }
    100% {
      transform: translateY(0) rotate(0deg);
    }
  }

  .m-headingForT-dav-bgs__boat {
    left: 27vw;
    top: 1.3vw;
    width: 55vw;
    animation: m-headingForT-dav-bgs__boat 4s ease-in-out infinite;
    will-change: transform;
  }

  .m-headingForT-dav-bgs__pinkbean {
    left: 20.5vw;
    top: 21.1vw;
    width: 8vw;
    z-index: 2;
  }
  .m-headingForT-dav-bgs__robot {
    left: 27vw;
    top: 20.9vw;
    width: 4.57vw;
    z-index: 1;
  }
  .m-headingForT-dav-bgs__bancho {
    right: 26.3vw;
    top: 20.3vw;
    width: 5.4vw;
  }
  .m-headingForT-dav-bgs__dave {
    right: 19.5vw;
    top: 22.8vw;
    width: 7.2vw;
  }
  .m-headingForT-dav-bgs__yeti-mushroom {
    width: 23vw;
    top: 88vw;
    left: 0.9vw;
    z-index: 4;
  }
  .m-headingForT-dav-bgs__rock-left {
    width: 23.8vw;
    top: 98.5vw;
    left: 0;
    z-index: 3;
  }
  .m-headingForT-dav-bgs__dave-big {
    width: 16vw;
    top: 84.3vw;
    right: 1.5vw;
    z-index: 4;
  }
  .m-headingForT-dav-bgs__rock-right {
    width: 30.6vw;
    top: 106.5vw;
    right: 0;
    z-index: 3;
  }
  .m-headingForT-dav-bgs__character-1 {
    width: 22vw;
    bottom: 89.7vw;
    left: 16.6vw;
    z-index: 1;
  }
  .m-headingForT-dav-bgs__character-2 {
    width: 18vw;
    bottom: 92vw;
    right: 18.5vw;
    z-index: 1;
  }
  .m-headingForT-dav-bgs__character-3 {
    width: 21vw;
    bottom: 2vw;
    left: 15vw;
    z-index: 3;
  }
  .m-headingForT-dav__logo {
    margin: 12.5vw 0 1.5vw;
    width: 32vw;
    height: auto;
  }

  .m-headingForT-dav__video {
    border: 3px solid #ffd02d;
    outline: 3px solid #0f648d;
    background: #0f648d;
    display: inline-block;
    position: relative;
    z-index: 10;
    width: 84vw;
    height: 47vw;
    padding: 3px;
    margin: 1.3vw 0 2vw;
    overflow: hidden;
    iframe {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .m-headingForT-dav-top-title {
    text-shadow: 2px 2px rgba(black, 0.4);
    margin-bottom: 0.8vw;
  }
  .m-headingForT-dav-box1 {
    margin-bottom: 4.5vw;
  }
  .m-headingForT-dav-box1-items {
    display: flex;
    align-items: stretch;
    gap: 3vw;
  }
  .m-headingForT-dav-box1-item {
    position: relative;
    flex: 1 1 0;
    &:after {
      content: '';
      width: 1px;
      height: 100%;
      position: absolute;
      right: -1.56vw;
      top: 0;
      background: url('~@/assets/images/microsites/headingfortomorrow/dave/box1/split-line.png') no-repeat center center /
        auto 100%;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
  .m-headingForT-dav-box1-item--2 {
    .m-headingForT-dav-box1-item__title {
      width: 10vw;
    }
  }
  .m-headingForT-dav-box1-item--3 {
    .m-headingForT-dav-box1-item__title {
      width: 10vw;
    }
  }
  .m-headingForT-dav-box1-item__headshot {
    width: 4.5vw;
    height: auto;
    margin-bottom: 0.5vw;
  }
  .m-headingForT-dav-box1-item__title {
    width: 14vw;
    margin: 0 auto 0.6vw;
    font-size: 1.6vw;
    line-height: 1em;
    margin-bottom: 0.6vw;
  }
  .m-headingForT-dav-box1-item__p {
    font-size: 0.9vw;
    line-height: 1em;
    height: 5.8vw;
    display: flex;
    align-items: center;
    margin-bottom: 0.8vw;
    :deep(span) {
      color: #ffd02d;
    }
  }
  .m-headingForT-dav-box1-item__ss {
    width: 15.8vw;
    height: auto;
  }
  .m-headingForT-dav-box1__btn {
    margin-bottom: 8vw;
  }
  .m-headingForT-dav-box2 {
    margin-bottom: 11vw;
  }
  .m-headingForT-sia-box2__top-content {
    display: flex;
    gap: 2.5vw;
    margin-bottom: 2vw;
    align-items: center;
    position: relative;
    z-index: 2;
  }
  .m-headingForT-sia-box2__text-wrapper {
    font-size: 1.2vw;
    padding-right: 1.2vw;
    display: flex;
    sup {
      font-size: 0.7vw;
    }
  }
  .m-headingForT-sia-box2__ss {
    width: 26vw;
    flex-grow: 0;
    flex-shrink: 0;
  }
  .m-headingForT-sia-box2__video {
    width: 53vw;
    height: 29.5vw;
    position: relative;
    z-index: 2;
    border: 1px solid #80d8ff;
    overflow: hidden;
    iframe {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .m-headingForT-dav-box2__bg {
    position: absolute;
    right: 0;
    top: -2.2vw;
    width: 26vw;
    height: 19vw;
    background: url('~@/assets/images/microsites/headingfortomorrow/dave/box2/bg.png') no-repeat center center / 100%
      auto;
  }
  .m-headingForT-dav-box2-titles {
    width: 30vw;
    margin: 0 auto;
    text-shadow: 3px 3px 2px rgba(#0f648d, 0.9);
    sup {
      font-size: 1.2vw;
    }
  }
  .m-headingForT-dav-box3 {
    margin-bottom: 4.5vw;
  }
  .m-headingForT-dav-box3-titles {
    text-shadow: 3px 3px 2px rgba(#0f648d, 0.9);
  }
  .m-headingForT-dav-box3__text {
    width: 80%;
    margin: 0 auto;
  }

  .m-headingForT-sia-box3__learn-more {
    position: relative;
    z-index: 10;
  }
  .tablet {
    .m-headingForT-dav {
      background: url('~@/assets/images/microsites/headingfortomorrow/dave/bg-tablet.jpg') no-repeat center top / 100%
        auto;
      text-align: center;
      padding-bottom: 19.5vw;
    }

    .m-headingForT-dav-bgs__boat {
      left: 8vw;
      top: 2.7vw;
      width: 105vw;
    }

    .m-headingForT-dav-bgs__character-1 {
      width: 42vw;
      bottom: 172vw;
      left: -15vw;
    }
    .m-headingForT-dav-bgs__character-2 {
      width: 35.5vw;
      bottom: 176vw;
      right: -10vw;
    }
    .m-headingForT-dav-bgs__character-3 {
      display: none;
    }
    .m-headingForT-dav__logo {
      width: 50vw;
      margin-top: 27.5vw;
      margin: 27.5vw 0 5vw;
    }
    .m-headingForT-dav-top-title {
      margin-bottom: 2.5vw;
    }
    .m-headingForT-dav-bgs__pinkbean {
      width: 14vw;
      left: 1.3vw;
      top: 43.7vw;
    }

    .m-headingForT-dav-bgs__robot {
      left: 12.5vw;
      top: 41.8vw;
      width: 8.57vw;
    }
    .m-headingForT-dav__video {
      width: 95vw;
      height: 54vw;
      border: 2px solid #ffd02d;
      outline: 2px solid #0f648d;
      padding: 2px;
    }
    .m-headingForT-dav-bgs__bancho {
      right: 14.3vw;
      top: 40.3vw;
      width: 10.4vw;
    }

    .m-headingForT-dav-bgs__dave {
      right: 0.8vw;
      top: 43.8vw;
      width: 15.2vw;
    }
    .m-headingForT-dav-bgs__rock-left,
    .m-headingForT-dav-bgs__dave-big,
    .m-headingForT-dav-bgs__bubble {
      display: none;
    }
    .m-headingForT-dav-box1-items {
      gap: 2.7vw;
    }
    .m-headingForT-dav-box1-item {
      &:after {
        right: -1.48vw;
      }
    }
    .m-headingForT-dav-box1-item--3 {
      .m-headingForT-dav-box1-item__p {
        width: 80%;
      }
    }
    .m-headingForT-dav-box1-item__title {
      width: 20vw;
      font-size: 3vw;
      margin-bottom: 1vw;
    }
    .m-headingForT-dav-box1-item__p {
      width: 95%;
      margin: 0 auto;
      height: 17vw;
      font-size: 1.8vw;
      line-height: 1.1em;
      margin-bottom: 2vw;
    }
    .m-headingForT-dav-box1-item__ss {
      width: 26.8vw;
    }
    .m-headingForT-dav-box1-item__headshot {
      width: 8.5vw;
    }
    .m-headingForT-dav-box1__btn {
      margin-bottom: 22vw;
    }
    .m-headingForT-dav-box2-titles {
      width: 57vw;
      margin-bottom: 8vw;
      sup {
        font-size: 2.5vw;
      }
    }
    .m-headingForT-dav-box2 {
      margin-bottom: 21.5vw;
    }
    .m-headingForT-sia-box2__ss {
      width: 42vw;
    }
    .m-headingForT-sia-box2__top-content {
      margin-bottom: 5vw;
    }
    .m-headingForT-sia-box2__text-wrapper {
      font-size: 2.4vw;
      width: 100%;
      sup {
        font-size: 1.4vw;
      }
    }
    .m-headingForT-dav-box2__bg {
      right: -1vw;
      top: -8.2vw;
      width: 47vw;
      height: 40vw;
    }
    .m-headingForT-sia-box2__text {
      width: 32vw;
      margin: 0 auto 0;
    }
    .m-headingForT-sia-box2__video {
      width: 87vw;
      height: 49vw;
    }
    .m-headingForT-dav-box3-titles {
      margin-bottom: 8vw;
    }
    .m-headingForT-dav-box3__text {
      width: 87%;
    }
  }
  .mobile {
    .m-headingForT-dav {
      background: url('~@/assets/images/microsites/headingfortomorrow/dave/bg-mobile.jpg') #032130 no-repeat center top /
        100% auto;
      padding-bottom: 16.5vw;
    }
    .m-headingForT-dav-bgs__boat {
      left: -9vw;
      top: 4vw;
      width: 143vw;
    }
    .m-headingForT-dav__logo {
      margin: 42vw 0 4.2vw;
      width: 88vw;
    }
    .m-headingForT-dav-top-title {
      margin-bottom: 32vw;
    }

    .m-headingForT-dav__video {
      width: 96vw;
      height: 54vw;
      border: 1px solid rgba(#80d8ff, 0.7);
      outline: none;
      padding: 0px;
    }
    .m-headingForT-dav-bgs__pinkbean {
      left: 14.8vw;
      top: 85.2vw;
      width: 24vw;
    }
    .m-headingForT-dav-bgs__robot {
      left: 34vw;
      top: 83.1vw;
      width: 14vw;
    }
    .m-headingForT-dav-bgs__bancho {
      right: 33vw;
      top: 83.9vw;
      width: 15.4vw;
    }
    .m-headingForT-dav-bgs__dave {
      right: 11vw;
      top: 88.2vw;
      width: 23vw;
    }
    [class^='m-headingForT-dav-bgs__character-'] {
      display: none;
    }

    .m-headingForT-dav-bgs__dave-big,
    .m-headingForT-dav-bgs__rock-right,
    .m-headingForT-dav-bgs__rock-left,
    .m-headingForT-dav-bgs__yeti-mushroom,
    .m-headingForT-dav-bgs__bubble {
      display: none;
    }
    .m-headingForT-dav-box1 {
      margin-bottom: 10vw;
    }
    .m-headingForT-dav-box1-items {
      flex-direction: column;
    }
    .m-headingForT-dav-box1-item {
      margin-bottom: 7vw;
      &:after {
        right: auto;
        top: auto;
        left: 50%;
        bottom: -4.5vw;
        background: url('~@/assets/images/microsites/headingfortomorrow/dave/box1/split-line-mobile.png') no-repeat
          center center / 140% auto;
        transform: translateX(-50%);
        height: 1px;
        width: 100%;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .m-headingForT-dav-box1-item__title {
      font-size: 5.6vw;
      margin-bottom: 2vw;
      width: 90%;
    }
    .m-headingForT-dav-box1-item__p {
      font-size: 4.8vw;
      line-height: 1.15em;
      height: auto;
      margin-bottom: 4vw;
    }
    .m-headingForT-dav-box1-item__p-text {
      width: 89%;
      margin: 0 auto;
    }
    .m-headingForT-dav-box1-item__ss {
      width: 86.8vw;
      height: auto;
    }

    .m-headingForT-dav-box1-item__headshot {
      width: 26.5vw;
      margin-bottom: 4vw;
    }

    .m-headingForT-dav-box1__btn {
      margin-bottom: 11vw;
    }

    .m-headingForT-dav-box2 {
      margin-bottom: 17vw;
    }

    .m-headingForT-sia-box2__top-content {
      flex-direction: column;
    }
    .m-headingForT-sia-box2__ss {
      width: 86vw;
      margin-bottom: 2vw;
    }

    .m-headingForT-sia-box2__text-wrapper {
      font-size: 5vw;
      width: 75%;
      margin-bottom: 2vw;
      sup {
        font-size: 3.2vw;
      }
    }
    .m-headingForT-sia-box2__video {
      width: 87vw;
      height: 49vw;
      margin: 0 auto;
    }

    .m-headingForT-dav-box2-titles {
      width: 70vw;
      sup {
        font-size: 3.7vw;
      }
    }

    .m-headingForT-dav-box3__text {
      width: 95%;
    }
  }
</style>
